import { render, staticRenderFns } from "./RemoveAcc.vue?vue&type=template&id=8a9d889c&"
import script from "./RemoveAcc.vue?vue&type=script&lang=js&"
export * from "./RemoveAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports